<template>
	<div class="level-container">
		<div class="btn-group">
			<Commonbtn backgroundColor="#FFF" :optional="addOptional" title="新增" fontSize="14px" @btnclick="add"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" :optional="updateOptional" :useAutoOptional="false" title="修改" fontSize="14px" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" :optional="delOptional" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="exportData"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" :optional="saveOptional" title="保存" fontSize="14px" @btnclick="save"
				:src="require('@/assets/icon/bc.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" :optional="abolishOptional" title="取消" fontSize="14px" @btnclick="abolish"
				:src="require('@/assets/icon/qux.png')">
			</Commonbtn>
		</div>

		<div class="main-content">
			<div class="dialogleftMask" v-if="dialogMaskleftfalg"></div>
			<div class="content-wrapper">
				<div class="tree-section" @click="treeClick">
					<div class="tree-title">树状列表</div>
					<div class="tree-content">
						<el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
					</div>
				</div>

				<div class="form-section">
					<div class="form-title">节点信息</div>
					<div class="form-content">
						<Commondropdownlist ref="levelNodeRef" v-for="(item, index) in formdata" :key="index"
							:options="item.options" :btx="item.btx" :inputdata="item.inputdata" :title="item.title"
							:fontSize="item.fontSize" :color="item.color" :lablewith="item.lablewith"
							:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
							:width="item.width" :disabled="item.disabled">
						</Commondropdownlist>
					</div>
				</div>

				<div class="dialogMask" v-if="dialogMaskfalg"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue';
	import Commonbtn from '../../../components/common-btn.vue';
	import utils from '../../../common/utils';

	import {
		GetLEVELList,
		ExportLEVEL,
		AddLEVEL,
		EditLEVEL,
		DeleteLEVEL
	} from '@/api/newsapi';

	export default {
		components: {
			Commondropdownlist,
			Commonbtn
		},
		data() {
			return {
				// 树状数据
				treeData: [],
				// 默认树属性
				defaultProps: {
					children: 'Nodes',
					label: 'NodeName'
				},
				// 遮罩层控制
				dialogMaskfalg: true, // 右边禁用
				dialogMaskleftfalg: false, // 左边启用
				// 按钮状态
				addOptional: false,
				updateOptional: true,
				delOptional: true,
				saveOptional: true,
				abolishOptional: true,
				// 保存状态：1-修改，2-新增
				saveState: null,
				// 当前选中节点
				currentNode: null,
				// 节点ID
				NodeID: '',
				// 表单数据
				formdata: [{
						inputdata: '',
						title: '父级节点',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'cascaderNodeParent',
						width: '300px',
						lablewith: '100px',
						treeData: [],
						disabled: false
					},
					{
						inputdata: '',
						title: '节点名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '290px',
						lablewith: '100px',
						disabled: false
					},
					{
						inputdata: '',
						title: 'CRM编号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '290px',
						lablewith: '100px',
						disabled: false
					}
				]
			};
		},
		mounted() {
			this.getTreeData();
		},
		methods: {
			// 获取树状列表
			async getTreeData() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载树状列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				try {
					let {
						code,
						data
					} = await GetLEVELList({});
					if (code === 0) {
						this.treeData = data;
						this.formdata[0].options = data;
					}
				} catch (error) {
					this.$message.error('加载树状列表失败');
				} finally {
					loading.close();
				}
			},
			// 处理节点点击
			handleNodeClick(data) {
				this.currentNode = data;
				this.NodeID = data.NodeID;
				this.formdata[0].inputdata = data.ParentNodeID || '';
				this.formdata[1].inputdata = data.NodeName || '';
				this.formdata[2].inputdata = data.Path || '';
				// 更新按钮状态
				this.updateOptional = false;
				this.delOptional = false;
				this.addOptional = false;
			},
			// 树区域点击
			treeClick() {
				// 清空表单
				this.formdata[0].inputdata = '';
				this.formdata[1].inputdata = '';
				this.formdata[2].inputdata = '';
				// 更新按钮状态
				this.updateOptional = true;
				this.delOptional = true;
				this.addOptional = false;
				this.currentNode = null;
				this.NodeID = '';
			},
			// 新增
		add() {
			this.saveState = 2;
			this.dialogMaskfalg = false;
			this.dialogMaskleftfalg = true;
			this.saveOptional = false;
			this.abolishOptional = false;
			this.updateOptional = true;
			this.delOptional = true;
			// 获取树状列表用于编辑
			this.getTreeData();
			// 清空表单
			this.formdata[1].inputdata = '';
			this.formdata[2].inputdata = '';
			this.formdata[0].disabled = false;
			// 如果有当前选中节点，自动设置父级节点为当前选中节点
			if (this.currentNode) {
				this.formdata[0].inputdata = this.currentNode.NodeID;
			}
		},
			// 修改
			update() {
				if (!this.currentNode) {
					this.$message.error('请选择要修改的节点');
					return;
				}
				this.saveState = 1;
				this.dialogMaskfalg = false;
				this.dialogMaskleftfalg = true;
				this.saveOptional = false;
				this.abolishOptional = false;
				this.addOptional = true;
				this.delOptional = true;
				this.formdata[0].disabled = true;
			},
			// 删除
			del() {
				if (!this.currentNode) {
					this.$message.error('请选择要删除的节点');
					return;
				}
				this.$confirm('确认要删除该节点吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					try {
						let {
							code,
							message
						} = await DeleteLEVEL({
							Code: this.NodeID
						});
						if (code === 0) {
							this.$message.success('删除成功');
							this.getTreeData();
							// 清空选择
							this.currentNode = null;
							this.NodeID = '';
							this.formdata[0].inputdata = '';
							this.formdata[1].inputdata = '';
							// 更新按钮状态
							this.updateOptional = true;
							this.delOptional = true;
							this.addOptional = false;
						} else {
							this.$message.error(message || '删除失败');
						}
					} catch (error) {
						this.$message.error('删除失败');
					}
				}).catch(() => {
					// 取消删除
				});
			},
			// 保存
			save() {
				if (this.saveState === 1) {
					this.editLevel();
				} else if (this.saveState === 2) {
					this.addLevel();
				}
			},
			// 取消
			abolish() {
				this.dialogMaskfalg = true;
				this.dialogMaskleftfalg = false;
				this.saveOptional = true;
				this.abolishOptional = true;
				this.updateOptional = true;
				this.addOptional = false;
				this.delOptional = true;
				// 清空表单
				this.formdata[0].inputdata = '';
				this.formdata[1].inputdata = '';
				this.formdata[2].inputdata = '';
				this.formdata[0].disabled = false;
			},
			// 新增节点
			async addLevel() {
				try {
					let {
						code,
						message
					} = await AddLEVEL({
						ParentCode: this.$refs.levelNodeRef[0].modelvalue,
						Name: this.$refs.levelNodeRef[1].modelvalue,
						CRMCode: this.$refs.levelNodeRef[2].modelvalue
					});
					if (code === 0) {
						this.$message.success('新增成功');
						this.refreshData();
					} else {
						this.$message.error(message || '新增失败');
					}
				} catch (error) {
					this.$message.error('新增失败');
				}
			},
			// 修改节点
			async editLevel() {
				try {
					let {
						code,
						message
					} = await EditLEVEL({
						Code: this.NodeID,
						Name: this.$refs.levelNodeRef[1].modelvalue,
						CRMCode: this.$refs.levelNodeRef[2].modelvalue
					});
					if (code === 0) {
						this.$message.success('修改成功');
						this.refreshData();
					} else {
						this.$message.error(message || '修改失败');
					}
				} catch (error) {
					this.$message.error('修改失败');
				}
			},
			// 刷新数据
			refreshData() {
				this.getTreeData();
				this.abolish();
			},
			// 导出
			async exportData() {
				try {
					let res = await ExportLEVEL({});
					if (res) {
						let date = new Date();
						let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`;
						utils.downloadFile(res, `LEVEL层级${str}`, "xlsx");
					} else {
						this.$message.warning('导出失败');
					}
				} catch (error) {
					this.$message.error('导出失败');
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.level-container {
		padding: 20px;
		background-color: #FFFFFF;
	}

	.btn-group {
		margin-bottom: 20px;
		margin-left: 9px;

		button {
			margin-right: 10px;
		}
	}

	.main-content {
		position: relative;
	}

	.content-wrapper {
		display: flex;
		justify-content: space-around;
		position: relative;
	}

	.tree-section,
	.form-section {
		width: 45%;
		border: 1px solid #e6e6e6;
		border-radius: 4px;
		padding: 15px;
	}

	.tree-title,
	.form-title {
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 15px;
		color: #333;
	}

	.tree-content {
		height: 400px;
		overflow-y: auto;
	}

	.form-content {
		height: 400px;
		overflow-y: auto;
	}

	.dialogMask {
		width: 600px;
		height: 468px;
		background-color: #ffffff;
		opacity: 0.5;
		position: absolute;
		margin-left: 50%;
		cursor: no-drop;
		z-index: 999;
	}

	.dialogleftMask {
		width: 600px;
		height: 450px;
		background-color: #ffffff;
		opacity: 0.5;
		position: absolute;
		cursor: no-drop;
		z-index: 999;
		left: 44px;
		top: 30px;
	}
</style>
